/**
 * Shared coverflow position utility.
 * Applies 3D drum-style transforms to a list of card elements.
 *
 * @param {Element} container            Root element to query cards within
 * @param {string}  selector             CSS selector for card elements
 * @param {number}  activeIdx            Index of the currently centered card
 * @param {object}  [opts]
 * @param {number}  [opts.scale=0.88]        Scale of adjacent (non-active) cards
 * @param {number}  [opts.rotateX=14]        rotateX degrees magnitude for adjacent cards
 * @param {number}  [opts.opacity=0.55]      Opacity of adjacent cards
 * @param {number}  [opts.translateY=68]     translateY px magnitude for adjacent cards
 * @param {boolean} [opts.activeClass=false] Toggle CSS class 'active' on the center card
 */
export function updateCoverflow(container, selector, activeIdx, opts = {}) {
  const {
    scale       = 0.88,
    rotateX     = 14,
    opacity     = 0.55,
    translateY  = 68,
    activeClass = false,
  } = opts

  const cards = container.querySelectorAll(selector)
  cards.forEach((card, i) => {
    const offset = i - activeIdx
    const abs = Math.abs(offset)

    if (abs > 1) { card.style.display = 'none'; return }
    card.style.display = 'flex'

    let sc, rx, op, ty
    if (offset === 0) {
      sc = 1.0; rx = 0; op = 1.0; ty = 0
    } else {
      sc = scale
      rx = offset > 0 ? rotateX : -rotateX
      op = opacity
      ty = offset * translateY
    }

    card.style.transform     = `translateY(${ty}px) rotateX(${rx}deg) scale(${sc})`
    card.style.opacity       = op
    card.style.zIndex        = 10 - abs
    card.style.pointerEvents = 'auto'

    if (activeClass) card.classList.toggle('active', offset === 0)
  })
}
